import { useSuspenseCertificateAuthoritiesQuery } from '#api/certificate-authorities.queries.ts';
import { DEFAULT_CERTIFICATE_AUTHORITIES_PAGE_SIZE } from '#api/certificate-authorities.ts';
import { TableLayout } from '#components/patterns/layouts/table/TableLayout.tsx';
import { TableFooter } from '#components/patterns/table/table-footer/TableFooter.tsx';
import { useSavedPageSize } from '#hooks/useSavedPageSize.tsx';
import { useUrlParam } from '#hooks/useUrlParam.ts';
import { EmptyCertificateAuthorities } from '../empty/EmptyCertificateAuthorities.tsx';
import { CertificateAuthoritiesList } from '../list/CertificateAuthoritiesList.tsx';

export function CertificateAuthoritiesPage() {
  const [cursor, setCursor] = useUrlParam('cursor');
  const [pageSize, setPageSize] = useSavedPageSize({ defaultPageSize: DEFAULT_CERTIFICATE_AUTHORITIES_PAGE_SIZE });
  const {
    data: { metadata, data: certificateAuthorities },
    isFetching,
  } = useSuspenseCertificateAuthoritiesQuery(cursor, pageSize);

  return !certificateAuthorities.length ?
      <EmptyCertificateAuthorities />
    : <TableLayout
        header="Certificate Authorities"
        pagination={
          <TableFooter
            entityType="Certificate Authorities"
            pageSize={pageSize}
            metadata={metadata}
            isFetching={isFetching}
            setCursor={setCursor}
            onPageSizeChange={setPageSize}
          />
        }
      >
        <CertificateAuthoritiesList data={certificateAuthorities} isFetching={isFetching} />
      </TableLayout>;
}
